var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlashlight = function SvgIconFlashlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10.25a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 7.247v.004c.002.376.123.741.348 1.043l.001.002 1.901 2.54V21A1.75 1.75 0 0 0 9 22.75h6A1.75 1.75 0 0 0 16.75 21V10.836l1.9-2.54.003-.002A1.76 1.76 0 0 0 19 7.25V3a1.75 1.75 0 0 0-1.75-1.75H6.75A1.75 1.75 0 0 0 5 3zM7 7v.164l1.902 2.542c.225.302.346.667.348 1.043V20.75h5.5V10.749c.002-.376.123-.741.348-1.043l.001-.002L17 7.164V7zm0-2h10V3.25H7z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFlashlight;